<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="submitLoading"
    destroyOnClose
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="formRef"
      :model="form"
      :rules="rules"
      :labelCol="{ span: 6 }"
      :wrapperCol="{ span: 16 }"
    >
      <a-form-model-item label="物料编码" prop="itemCode">
        <a-input v-model="form.itemCode" :maxLength="64" placeholder="请输入物料编码" />
      </a-form-model-item>
      <a-form-model-item label="大工序" prop="mainProcessCode">
        <a-select v-model="form.mainProcessCode" allowClear placeholder="请选择大工序">
          <a-select-option v-for="item in mainProcessOptions" :key="item.lookupCode" :value="item.lookupCode">
            {{ item.lookupValue }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="子工序" prop="subProcessCode">
        <a-select v-model="form.subProcessCode" allowClear placeholder="请选择子工序">
          <a-select-option v-for="item in subProcessOptions" :key="item.lookupCode" :value="item.lookupCode">
            {{ item.lookupValue }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="工价" prop="unitPrice">
        <a-input-number v-model="form.unitPrice" :min="0" :precision="2" style="width: 100%" placeholder="请输入工价" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  apiProductionProcessAdd,
  apiProductionProcessDetail,
  apiProductionProcessUpdate
} from '@/api/mes/basedata/productionProcess'

const emptyForm = () => ({
  id: undefined,
  itemCode: undefined,
  mainProcessCode: undefined,
  subProcessCode: undefined,
  unitPrice: undefined
})

export default {
  name: 'ProductionProcessForm',
  data () {
    return {
      visible: false,
      submitLoading: false,
      title: '新增生产工艺',
      form: emptyForm(),
      mainProcessOptions: [],
      subProcessOptions: [],
      rules: {
        itemCode: [{ required: true, message: '请输入物料编码', trigger: 'blur' }],
        mainProcessCode: [{ required: true, message: '请选择大工序', trigger: 'change' }],
        subProcessCode: [{ required: true, message: '请选择子工序', trigger: 'change' }],
        unitPrice: [{ required: false, message: '请输入工价', trigger: 'change' }]
      }
    }
  },
  methods: {
    open (record) {
      this.visible = true
      this.form = emptyForm()
      this.title = record && record.id ? '编辑生产工艺' : '新增生产工艺'
      this.loadLookupOptions()
      if (record && record.id) {
        apiProductionProcessDetail(record.id).then(response => {
          this.form = Object.assign(emptyForm(), response.data)
        })
      }
    },
    loadLookupOptions () {
      this.getLookupList('MES_MAIN_PROCESS', 'mainProcessOptions')
      this.getLookupList('MES_SUB_PROCESS', 'subProcessOptions')
    },
    getLookupList (lookupType, target) {
      this.getLookupListData({ lookupType, current: 1, pageSize: 999 }).then(response => {
        this[target] = response.rows || []
      })
    },
    handleSubmit () {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return
        }
        const request = this.form.id ? apiProductionProcessUpdate : apiProductionProcessAdd
        this.submitLoading = true
        request(this.form).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error(response.msg || '保存失败')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    handleCancel () {
      this.visible = false
      this.form = emptyForm()
    }
  }
}
</script>
